export default {
  title: 'Allekirjoitettu / Live-raportti',
  column_groups: {
    current_period: 'Nykyinen jakso',
  },
  fields: {
    name: 'Nimi',
    area: 'Alue',
    signed: 'Allekirjoitettu',
    live: 'Live',
    going_live: 'Käyttöönotto',
    going_live_avg: 'Käyttöönoton keskiarvo',
    churned: 'Menetetty',
    not_live: 'Ei live',
    live_ratio: 'Live-suhde',
    avg_mrr: 'Keskim. MRR',
  },
  manager_status_filters: {
    active: 'Aktiivinen',
    inactive: 'Ei aktiivinen',
    all: 'Kaikki',
  },
  status_filters: {
    all: 'Kaikki',
    not_live: 'Ei live',
  },
  drawer: {
    title: '{{column}} — {{managerName}}',
    subtitle_one: '{{count}} ravintola',
    subtitle_other: '{{count}} ravintolaa',
    empty: 'Ravintoloita ei löytynyt.',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui, päivitä sivu',
  },
};
